var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGsIconThumbsDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8305 17.4127C11.5505 17.9767 10.9752 18.3333 10.3455 18.3333C8.8117 18.3333 7.64618 16.9611 7.88115 15.4487L8.20979 13.3333H4.99157C2.97377 13.3333 1.42598 11.548 1.69748 9.55L2.26366 5.38334C2.48781 3.73377 3.89288 2.5 5.55775 2.5H16.6666C17.5871 2.5 18.3333 3.24619 18.3333 4.16667V10C18.3333 10.9205 17.5871 11.6667 16.6666 11.6667H14.6833L11.8305 17.4127ZM14.9999 10H16.6666V4.16667H14.9999V10Z",
    fill: "#FF1A51"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGsIconThumbsDown);
export default __webpack_public_path__ + "static/media/gs_icon_thumbs_down.a031b24c27beaca4f8942dadbf56bd94.svg";
export { ForwardRef as ReactComponent };